module.exports = __webpack_public_path__ + "media/entities/2014-5bb1ed52.png";